import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

/*Validador entre 2 contraseñas*/
export function MustMatchForm(controlName: string, matchingControlName: string, controlName2: string, matchingControlName2: string) {
  return (formGroup: FormGroup) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];
    const control2 = formGroup.controls[controlName2];
    const matchingControl2 = formGroup.controls[matchingControlName2];
    // set error on matchingControl if validation fails
    if (control.value !== matchingControl.value) {
      // console.log('contra mal')
      matchingControl.setErrors({ mustMatch: true });
    } else {
      // console.log('contrab')
      matchingControl.setErrors(null);
    }
    // set error on matchingControl if validation fails of second
    if (control2.value !== matchingControl2.value) {
      // console.log('contra mal')
      matchingControl2.setErrors({ mustMatch: true });
    } else {
      // console.log('contrab')
      matchingControl2.setErrors(null);
    }
  }
}
/* Validador entre 2 contraseñas */
export function MustMatchForm2(controlName: string, matchingControlName: string, errorName: string): ValidatorFn {
  return (controls: AbstractControl) => {
    const control = controls.get(controlName);
    const matchingControl = controls.get(matchingControlName);

    // Comparar los valores del formulario
    if (control.value !== matchingControl.value) {
      return { [errorName]: true };
    } else {
      return null;
    }
  }
}

export function MustMatchForm3(controlName: string, matchingControlName: string): ValidatorFn {
  return (formGroup: any) => {
    const control = formGroup.controls[controlName];
    const matchingControl = formGroup.controls[matchingControlName];

    if (control.value !== matchingControl.value) {
      return { mustMatch: true }; 
    }

    return null;
  }
}

